import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5tf294i414: FaireBrandEntity = {
  token: "b_5tf294i414",
  type: "brand",
  name: "Firelli Hot Sauce",
  avatarUrl:
    "https://cdn.faire.com/fastly/f0243d0103c950b18f6a8c4a4e1e6e5eeaac80c8f62160e3e4b73eb391f88e46.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4ebc8918f5cb2bb2ac216bc7b9ee0ebedb23e79f09f8fb1766f04e86e011f950.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/f0243d0103c950b18f6a8c4a4e1e6e5eeaac80c8f62160e3e4b73eb391f88e46.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4ebc8918f5cb2bb2ac216bc7b9ee0ebedb23e79f09f8fb1766f04e86e011f950.jpeg",
  location: "Montclair, NJ, USA",
  minimumOrderDollars: 120,
  rating: 4.7,
  reviewCount: 84,
  isInsider: true,
  description:
    "Handcrafted by the Zucatto family in Parma, Italy, Firelli is made with iconic Italian ingredients like Calabrian chili peppers, Balsamic vinegar from Modena, Porcini mushrooms, roasted red peppers, and a touch of Italian sea salt. Providing a medium heat with a rich and rounded spicy flavor, this latest spicy addition makes the perfect pairing for pizza, eggs, pasta, and more.",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:24.076Z",
    importedBy: "entity-db-cli",
  },
};
